/**
 * The add dialog's chosen option, made safe to use as a supplement row.
 *
 * react-select's "Create" option uses the raw typed text as both label and
 * value, trailing space included. That value becomes the row's `supplementId`,
 * and the backend trims ids, so an analysis of "creatine gummies " came back
 * as "creatine gummies", matched no row, and the form reported the row as
 * added mid-run (Tanu's staging test, 2026-10-02, case C1). Library options are
 * already clean, so trimming them changes nothing.
 *
 * @param {{label?: *, value?: *}|null} option
 * @returns {object|null} the option with label and value trimmed, or null when
 *   nothing but whitespace was typed
 */
export function normalizeSupplementOption(option) {
  if (!option) return null;
  const value = typeof option.value === 'string' ? option.value.trim() : option.value;
  const label = typeof option.label === 'string' ? option.label.trim() : option.label;
  if (value === '' || value == null) return null;
  return { ...option, value, label };
}

export default normalizeSupplementOption;
